<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useMapGetter } from 'dashboard/composables/store';

import Icon from 'dashboard/components-next/icon/Icon.vue';
import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();

const currentUser = useMapGetter('getCurrentUser');
const accountId = useMapGetter('getCurrentAccountId');

const isSuperAdmin = computed(() => currentUser.value?.type === 'SuperAdmin');

// The toggle is per account, so this points at the account's own super admin
// page rather than the instance-wide settings screen.
const accountSettingsUrl = computed(
  () => `/super_admin/accounts/${accountId.value}/edit`
);
</script>

<template>
  <section
    class="flex h-full w-full flex-col items-center justify-center bg-n-solid-1"
  >
    <div
      class="flex max-w-md flex-col rounded-xl border border-n-weak bg-n-solid-1 px-6 py-6 shadow"
    >
      <div class="mb-4 flex w-full items-center gap-2">
        <span
          class="flex size-6 items-center justify-center rounded-full bg-n-solid-blue"
        >
          <Icon
            class="size-[14px] flex-shrink-0 text-n-brand"
            icon="i-lucide-lock-keyhole"
          />
        </span>
        <span class="text-base font-medium text-n-slate-12">
          {{ t('FAZER_AI.INTERNAL_CHAT_DISABLED.TITLE') }}
        </span>
      </div>
      <template v-if="isSuperAdmin">
        <p class="mb-4 text-sm font-normal text-n-slate-11">
          {{ t('FAZER_AI.INTERNAL_CHAT_DISABLED.SUPERADMIN_DESCRIPTION') }}
        </p>
        <a :href="accountSettingsUrl" class="block w-full">
          <Button solid blue md class="w-full">
            {{ t('FAZER_AI.INTERNAL_CHAT_DISABLED.SUPERADMIN_ACTION') }}
          </Button>
        </a>
      </template>
      <p v-else class="text-sm font-normal text-n-slate-11">
        {{ t('FAZER_AI.INTERNAL_CHAT_DISABLED.DESCRIPTION') }}
      </p>
    </div>
  </section>
</template>
